export default __webpack_public_path__ + "static/media/basketball.b75fca68.svg";